__turbopack_context__.v({
  "card": "PrizeRedemptionCard-module__o8uwEG__card",
  "image": "PrizeRedemptionCard-module__o8uwEG__image",
  "imageWrapper": "PrizeRedemptionCard-module__o8uwEG__imageWrapper",
  "snowflake": "PrizeRedemptionCard-module__o8uwEG__snowflake",
  "subheading": "PrizeRedemptionCard-module__o8uwEG__subheading",
  "textContainer": "PrizeRedemptionCard-module__o8uwEG__textContainer",
  "title": "PrizeRedemptionCard-module__o8uwEG__title",
});
